import { Meter } from "../../../design/components";
import fieldTitle from "./fieldTitle";
import styles from "./mapping.module.css";
import type { CoverageDto } from "./types";

export function CoverageMeter({
  coverage,
  allOpen,
  onToggleAll,
}: {
  coverage: CoverageDto;
  allOpen: boolean;
  onToggleAll: () => void;
}) {
  const { resolved, total, gaps, gapLabels = {} } = coverage;
  const hasGaps = gaps.length > 0;
  const plural = gaps.length === 1 ? "" : "s";

  return (
    <header className={styles.rail}>
      <strong className={styles.score}>
        {resolved} of {total} required fields mapped
      </strong>
      <div className={styles.railMeter}>
        <Meter pct={total === 0 ? 100 : (resolved / total) * 100} />
      </div>
      {hasGaps && (
        <details className={styles.gapList}>
          <summary>
            {gaps.length} gap{plural}
          </summary>
          <ul>
            {gaps.map((name) => (
              <li key={name}>
                <a href={`#row-${name}`}>{fieldTitle({ ...gapLabels[name], ota: name })}</a>
              </li>
            ))}
          </ul>
        </details>
      )}
      {hasGaps && (
        <span className={styles.warn} role="alert">
          {gaps.length} required field{plural} unmapped
        </span>
      )}
      <button
        type="button"
        className={`btn btn-sm btn-ghost ${styles.toggleAll}`}
        aria-expanded={allOpen}
        onClick={onToggleAll}
      >
        {allOpen ? "Collapse all" : "Expand all"}
      </button>
    </header>
  );
}
